import React, { useState, useEffect } from "react";
import MyLoader from "../Spinner/MyLoader";
import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Link,
  Switch,
} from "react-router-dom";
import "../css/Admin_css/admin-customize.css";
import COLORS from "../resources/colors/COLORS";
import studentPhoto from "../../src/resources/images/EduOk.png";

const AdmissionLink = () => {
  const [loggedIn, setLoggedIn] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setLoggedIn(false);
    }
  }, []);

  if (!loggedIn) {
    return <Redirect to="/Login" />;
  }

  if (loading) {
    return <MyLoader />;
  }

  return (
    <Router>
      <Switch>
        <Route path="/AdminMain/AdmissionLink" exact>
          <div className="content" style={{ background: COLORS.white }}>
            <div className="content-header">
              <div className="leftside-content-header">
                <ul className="breadcrumbs">
                  <li>
                    <i className="fa fa-home" aria-hidden="true" />
                    <a href="#">Admission Link</a>
                  </li>
                </ul>
              </div>
            </div>
            <div
              className="bg_page_grey_rounded box_shadow"
              style={{ "--mMargin": "50px" }}
            >
              <div className="AdmissionLink-container">
                <div className="AdmissionLink-info-section">
                  <div className="AdmissionLink-school-logo">
                    <img src={studentPhoto} alt="School Logo" />
                  </div>
                  <div className="AdmissionLink-school-info">
                    <h2>Sarswati Public School</h2>
                    <p>
                      Teachers colony CHATT POKHAR, PF69+J8C, Purnia, Bihar
                      854301, India
                    </p>
                    <p>Contact Number: +123 456 7890</p>
                  </div>
                </div>
                <div className="AdmissionLink-separator"></div>
                <div className="AdmissionLink-admission-open">
                  <h3>Admission Open</h3>
                </div>
                <div className="AdmissionLink-links">
                  <a
                    href="http://eduok.in/PiZeroApi_Live/ver1/Printables/Adm/admission_inquiry.php?school_code=11"
                    className="AdmissionLink-button"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Apply Now
                  </a>
                  <button className="AdmissionLink-share-button">Share</button>
                </div>
              </div>
            </div>
          </div>
        </Route>
      </Switch>
    </Router>
  );
};

export default AdmissionLink;
